import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-layout-footer',
  templateUrl: './layout-footer.component.html',
  styleUrls: ['./layout-footer.component.css']
})
export class LayoutFooterComponent implements OnInit {

  constructor() { }

  isCommercialization: boolean = false;
  
  currentYear: number = new Date().getFullYear();
  ngOnInit(): void {
    this.isCommercialization = environment.isCommercialization;
  }

}
